import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCalculateDisabled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.75 1H13.25C13.775 1 14.125 1.35 14.125 1.875V2.43135L12.375 4.18135V2.75H3.625V5.375H11.1814L8.875 7.68135V7.125H7.125V8.875H7.68135L5.375 11.1814V10.625H3.625V12.375H4.18135L2 14.5564L2.37346 14.9298C2.06437 14.8027 1.875 14.5112 1.875 14.125V1.875C1.875 1.35 2.225 1 2.75 1ZM4.38478 15H13.25C13.775 15 14.125 14.65 14.125 14.125V5.25978L12.2598 7.125H12.375V12.375H10.625V8.75978L8.75978 10.625H8.875V12.375H7.125V12.2598L4.38478 15ZM3.625 8.875H5.375V7.125H3.625V8.875Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M13.8852 0.268006L0.408767 13.7444C0.0182426 14.1349 0.0182426 14.7681 0.408767 15.1586C0.799291 15.5491 1.43246 15.5491 1.82298 15.1586L15.2994 1.68222C15.6899 1.2917 15.6899 0.65853 15.2994 0.268006C14.9089 -0.122518 14.2757 -0.122518 13.8852 0.268006Z",
			fill: "currentColor"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 17,
			height: 17,
			fill: "white"
		})
	}) })]
});
export default SvgIconCalculateDisabled;
